import React from 'react'
import PropTypes from 'prop-types'

import IntlUtil from '../../../lib/intlutil.jsx'
import Input from '../../../common/form/input/input.jsx'

const ContactPersonRow = ({
  contact,
  index,
  showError,
  onChangeContactPerson,
  onKeyPressContactPerson,
  onFocusContactPerson,
  onDeleteContactPerson
}) => {
  return (
    <div className='formrow' key={index}>
      <div className='formcol2'>
        <Input
          type='text'
          name='contactperson_name'
          size={10}
          maxLength={100}
          key={index}
          label='contact.form.contactPersonPlaceholder'
          value={contact.name}
          validations={['email']}
          styleDotted
          prefixIcon='form-person'
          className='contact-add'
          onFocus={onFocusContactPerson.bind(this, 'name', index)}
          onKeyDown={onKeyPressContactPerson.bind(this, 'name', index)}
          onChange={onChangeContactPerson.bind(this, 'name', index)}
        />
      </div>
      <div className='formcol2'>
        <Input
          type='text'
          name='department'
          size={10}
          maxLength={100}
          key={index}
          label='contact.form.departmentPlaceholder'
          value={contact.department}
          styleDotted
          className='contact-add'
          onFocus={onFocusContactPerson.bind(this, 'department', index)}
          onKeyDown={onKeyPressContactPerson.bind(this, 'department', index)}
          onChange={onChangeContactPerson.bind(this, 'department', index)}
        />
      </div>
      <div className='formcol2'>
        <Input
          type='text'
          name='email'
          size={10}
          maxLength={100}
          key={index}
          label='contact.form.contactPersonEmailAddress'
          styleDotted
          value={contact.email}
          validations={['email']}
          error={showError}
          showPlaceholder={false}
          errorMsg={IntlUtil.convertMessage('contact.form.msgEmailError')}
          onFocus={onFocusContactPerson.bind(this, 'email', index)}
          onKeyDown={onKeyPressContactPerson.bind(this, 'email', index)}
          onChange={onChangeContactPerson.bind(this, 'email', index)}
        />
      </div>
      <div className='formcol2'>
        <Input
          type='text'
          name='phone'
          value={contact.phone}
          label='contact.form.contactPersonTelephonePlaceholder'
          size={10}
          maxLength={16}
          prefixIcon='form-call'
          styleDotted
          validations={['intlphone']}
          suffixIcon='form-input-delete'
          className='contact-add'
          onClickSuffix={onDeleteContactPerson.bind(this, 'email', index)}
          onChange={onChangeContactPerson.bind(this, 'phone', index)}
        />
      </div>
    </div>
  )
}

export default ContactPersonRow

ContactPersonRow.propTypes = {
  onChangeContactPerson: PropTypes.func.isRequired,
  onKeyPressContactPerson: PropTypes.func.isRequired,
  onFocusContactPerson: PropTypes.func.isRequired,
  onDeleteContactPerson: PropTypes.func.isRequired
}
